$(function () {
  var attempts = 0;
  var brandingInterval = setInterval(function () {
    var brandingHidden = false;

    $('.widerruf-form-block').each(function () {
      if (!this.shadowRoot) {
        return;
      }

      var $shadowRoot = $(this.shadowRoot);

      if (!$shadowRoot.find('[data-hide-widerruf-branding]').length) {
        $(
          '<style data-hide-widerruf-branding>' +
            '.widerruf-form-branding { display: none !important; }' +
            '.widerruf-form-step-pill { border-radius: 0 !important; }' +
          '</style>'
        )
          .appendTo($shadowRoot);
      }

      brandingHidden = true;
    });

    attempts += 1;

    if (brandingHidden || attempts >= 40) {
      clearInterval(brandingInterval);
    }
  }, 250);
});
